(function () {
    'use strict';

    angular
        .module('laekkerAI.tablet')
        .controller('KitchenVideoPlayerController', [function () {

            var $ctrl = this;

            $ctrl.$onInit = function () {
                angular.merge($ctrl, $ctrl.resolve);
            };
        }]);
})();